import { render, staticRenderFns } from "./park-parking-space.vue?vue&type=template&id=770aa18f&scoped=true&"
import script from "./park-parking-space.vue?vue&type=script&lang=js&"
export * from "./park-parking-space.vue?vue&type=script&lang=js&"
import style0 from "./park-parking-space.vue?vue&type=style&index=0&id=770aa18f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770aa18f",
  null
  
)

export default component.exports